import * as React from "react";
import PropTypes from "prop-types";
import prefixStyles from "nx-components/utils/prefixStyles";
import CustomPropTypes from "nexia_mobile/CustomPropTypes";
import { truncateAndCombineIcons } from "nexia_mobile/components/IconGroup";

const style = prefixStyles({
  margin: "0 auto",
  height: "3.5em",
  display: "flex",
  alignItems: "center",
});

export default class IconGroupTileWrapper extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    values: CustomPropTypes.keyedElementList.isRequired,
    unique: PropTypes.bool,
  };

  render() {
    const { children, values, unique } = this.props;

    const icons = truncateAndCombineIcons(values, unique);
    const hasThermostat = icons.some((icon) => icon.name === "thermostat");

    let maxWidth;
    if (icons.length === 4) {
      maxWidth = hasThermostat ? "6.5em" : "5.5em";
    } else {
      maxWidth = hasThermostat ? "7.5em" : "6.5em";
    }

    return (
      <div
        style={{
          ...style,
          maxWidth,
        }}
      >
        {children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Tiles/IconGroupTileWrapper.jsx